import {createAsyncThunk} from '@reduxjs/toolkit'

import {qs} from '@shared/helpers/queryString'

import {changeLocation} from '@web/actions/application'
import {redirectToEasyBookingResult} from '@web/actions/result'
import {OrderEntry, EntryType, ReasonType, ApplyFail} from '@web/core/constants'
import {ROUTER_ORDER_FAIL} from '@web/core/routes'
import {LanguageType} from '@web/i18n'
import {replace} from '@web/slices/router'

import {getChannelUrlMap, getOrderResultUrl} from '../utils'

import type {ThunkApi} from '../interfaces'

const resetPageScroll = () => window.scrollTo(0, 0)

/** 주문 완료로 이동에 필요한 처리  */
export const redirectToOrderResult = createAsyncThunk<
    void,
    {
        orderNo: string
        entry: Maybe<EntryType>
    },
    ThunkApi
>('redirectToOrderResult', async ({orderNo, entry}, {dispatch}) => {
    function redirectResult() {
        dispatch(
            changeLocation({
                type: 'REPLACE',
                url: getOrderResultUrl(entry, orderNo),
            }),
        )
        resetPageScroll()
    }
    if (entry === OrderEntry.EASY_BOOKING || entry === OrderEntry.LOCAL_PAY) {
        try {
            // route replace action 으로 이동시, /order/checkout/~~ 경로로 이동하여, 직접 이동으로 반영
            // 결제 시작 (startOrder) 부터 주문완료 (redirectToOrderResult) 까지의 transaction 을 검증하고 있으나,
            // 예약에서 redirectToOrderResult 를 catch 하지 못하고 있어 예외처리 되어 있습니다.
            await dispatch(redirectToEasyBookingResult(orderNo)).unwrap()
        } catch {
            redirectResult()
        }
    } else {
        redirectResult()
    }
})

/** 주문 완료로 이동에 필요한 처리  */
export const redirectToOrderFail = createAsyncThunk<
    void,
    {
        orderProcessNo: Maybe<string>
        failReason: string
        entry: Maybe<EntryType>
        language: LanguageType
    },
    ThunkApi
>('redirectToOrderFail', async ({orderProcessNo, entry, failReason, language}, {dispatch}) => {
    const resultUrlMap: Record<string, string> = {
        [OrderEntry.CHECKOUT]: ROUTER_ORDER_FAIL.MALL,
        [OrderEntry.NAVER_BLOG]: ROUTER_ORDER_FAIL.BLOG,
        [OrderEntry.EASY_BOOKING]: ROUTER_ORDER_FAIL.EASY_BOOKING,
        [OrderEntry.LOCAL_PAY]: ROUTER_ORDER_FAIL.LOCAL_PAY,
    }
    const resultUrl = (function () {
        if (window.location.pathname.includes('/ordersheet/')) {
            return getChannelUrlMap(entry ?? OrderEntry.CHECKOUT).FAIL.getHref()
        }
        if (entry) {
            return resultUrlMap[entry] ?? ROUTER_ORDER_FAIL.MALL
        }
        return ROUTER_ORDER_FAIL.MALL
    })()

    dispatch(
        replace(
            failReason === ReasonType.ORDER_PROCESS_ALREADY_STARTED
                ? qs.stringifyUrl({
                      url: `${resultUrl}/${orderProcessNo}/${ApplyFail.ORDER_PROCESS_ALREADY_STARTED}`,
                      query:
                          failReason === ReasonType.ORDER_PROCESS_ALREADY_STARTED
                              ? {
                                    language,
                                }
                              : {},
                  })
                : `${resultUrl}/${orderProcessNo}`,
        ),
    )
    resetPageScroll()
})
